import { render } from "./PromotionSection.vue?vue&type=template&id=4f42c3f8"
import script from "./PromotionSection.vue?vue&type=script&lang=js"
export * from "./PromotionSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__